import {
  TestimonialMultipleColumn as TestimonialMultipleColumnZDS,
  TestimonialMultipleColumnProps,
} from '@zapier/design-system';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';

export function TestimonialMultipleColumn(
  props: TestimonialMultipleColumnProps,
) {
  return (
    <TestimonialMultipleColumnZDS
      backgroundColor={props.backgroundColor}
      numberOfColumns={props.numberOfColumns}
      testimonials={props.testimonials.map((testimonial) => {
        return {
          ...testimonial,
          quote: (
            <RichTextHtml html={testimonial.quote as RichTextHTMLString} />
          ),
        };
      })}
    />
  );
}
